// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
// import ActivityModal from './ActivityModal';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { useSearchParams } from 'react-router-dom';
// import ReactPaginate from 'react-paginate';
// import { useAuth } from '../../../../context/AuthContext';
// import withPermission from '../../../../utils/withPermission';
// import Swal from 'sweetalert2';

// const ActivityList = ({ type, leadId, dealId }) => {
//     const [activities, setActivity] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedActivityId, setSelectedActivityId] = useState(null);
//     const [selectedActivityData, setSelectedActivityData] = useState(null);
//     const [errors, setErrors] = useState({});
//     const didFetchRef = useRef(false);
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(1);
//     const { id } = useParams();
//     const { roles, permissions } = useAuth();
//     const WithDeletePermission = withPermission(({ children }) => children, ['activity-delete']);
//     const WithEditPermission = withPermission(({ children }) => children, ['activity-edit']);
//     const WithCreatePermission = withPermission(({ children }) => children, ['activity-create']);
//     const [searchQuery, setSearchQuery] = useState('');
//     const debounceTimeoutRef = useRef(null);


//     useEffect(() => {
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchActivity(1, id, searchQuery);
//         }, searchQuery ? 1500 : 0);

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery]);
//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);

//     };
//     // const fetchActivity = async (page = 1) => {
//     //     try {
//     //         const backendUrl = process.env.REACT_APP_BACKEND_URL;

//     //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
//     //         const token = userInfo?.token;

//     //         const response = await axios.get(`${backendUrl}/api/activities`, {
//     //             headers: {
//     //                 'Authorization': `Bearer ${token}`,
//     //             },
//     //             params: {
//     //                 page,
//     //                 lead_id: id,
//     //                 search: searchQuery,

//     //             },
//     //         });

//     //         const activityData = response.data.data.data;

//     //         setActivity(activityData);
//     //         const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
//     //         setPageCount(totalPages);
//     //         setCurrentPage(page);
//     //     } catch (error) {
//     //         console.error('Error fetching activities:', error);
//     //     }
//     // };
//     const fetchActivity = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/activities`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params: {
//                     page,
//                     [`${type}_id`]: type === 'lead' ? leadId : dealId, // Use the correct ID based on the type
//                     search: searchQuery,
//                 },
//             });

//             const activityData = response.data.data.data;
//             setActivity(activityData);
//             const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
//             setPageCount(totalPages);
//             setCurrentPage(page);
//         } catch (error) {
//             console.error('Error fetching activities:', error);
//         }
//     };


//     const addActivity = async (newActivity) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             newActivity[`${type}_id`] = type === 'lead' ? leadId : dealId;
//             newActivity.type = type;
//             const response = await axios.post(`${backendUrl}/api/activities?${type}_id=${type === 'lead' ? leadId : dealId}`, newActivity, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const createdActivity = response.data?.data;

//             if (createdActivity) {
//                 setActivity((prevActivity) => [...prevActivity, createdActivity]);
//             } else {
//                 console.error('Creation failed, no data returned.');
//             }


//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.message) {
//                 return error.response.data.message; // Return validation errors
//             } else {
//                 console.error('Error adding activity:', error);
//             }
//         }
//     };

//     const editActivity = async (activityId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             updatedData[`${type}_id`] = type === 'lead' ? leadId : dealId;
//             const response = await axios.put(`${backendUrl}/api/activities/${activityId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedActivity = response.data?.data;

//             if (updatedActivity) {
//                 setActivity((prevActivity) =>
//                     prevActivity.map((activity) => (activity.id === updatedActivity.id ? updatedActivity : activity))
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {
//             if (error.response && error.response.data.message) {
//                 setErrors(error.response.data.message);
//             } else {
//                 console.error('Error updating activity:', error);
//             }
//         }
//     };

//     const deleteActivity = async (id) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 try {
//                     const backendUrl = process.env.REACT_APP_BACKEND_URL;

//                     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//                     const origin = localStorage.getItem('user-origin');
//                     const token = userInfo?.token;

//                     await axios.delete(` ${backendUrl}/api/activities/${id}`, {
//                         headers: {
//                             'Authorization': `Bearer ${token}`,
//                             'Tenant-Origin': origin,

//                         },
//                     });

//                     setActivity(activities.filter(activity => activity.id !== id));
//                     Swal.fire(
//                         "Deleted!",
//                         "The activity has been deleted.",
//                         "success"
//                     );
//                 } catch (error) {
//                     console.error('Error deleting activity:', error);
//                     Swal.fire(
//                         "Error!",
//                         "Failed to delete activity. Please try again.",
//                         "error"
//                     );
//                 }
//             }
//         });
//     };

//     const handleShowModal = (activityId = null) => {
//         if (activityId) {
//             const activityToEdit = activities.find(activity => activity.id === activityId);
//             setSelectedActivityData(activityToEdit || null); // Set data for editing
//         } else {
//             setSelectedActivityData(null); // Clear form data for creating new activity
//             setErrors({}); // Clear any errors
//         }
//         setSelectedActivityId(activityId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedActivityId(null);
//         setSelectedActivityData(null);
//         setErrors({});
//     };

//     const handlePageChange = ({ selected }) => {
//         const newPage = selected + 1;
//         setCurrentPage(newPage);
//         fetchActivity(newPage);
//     };
//     // Extract the content into a separate component for reusability
//     const ActivityContent = () => {
//         return (
//             <>
//                 <h4 className="mb-sm-0 font-size-18">Activity</h4>
//                 <div className="d-flex justify-content-end mb-2">
//                     {/* Search Box */}
//                     <div className="search-box me-2">
//                         <div className="position-relative">
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Search..."
//                                 value={searchQuery}
//                                 onChange={handleSearchChange}
//                             />
//                             <i className="bx bx-search-alt search-icon" />
//                         </div>
//                     </div>

//                     {/* Add Activity Button */}
//                     <WithCreatePermission>
//                         <button
//                             type="button"
//                             className="btn rounded-circle border d-flex align-items-center justify-content-center"
//                             style={{
//                                 width: "35px",
//                                 height: "35px",
//                                 padding: "5px",
//                                 backgroundColor: "ffffff",
//                                 borderColor: "#ccc",
//                                 color: "#333",
//                             }}
//                             onClick={() => handleShowModal()}
//                             data-bs-toggle="tooltip"
//                             data-bs-placement="top"
//                             id="tool"
//                             title="Add Activity"
//                         >
//                             <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
//                         </button>
//                     </WithCreatePermission>
//                 </div><br />

//                 <table id="datatable" className="table table-bordered dt-responsive nowrap w-100">
//                     <thead>
//                         <tr>
//                             <th>#</th>
//                             <th>Subject</th>
//                             <th>Activity Type</th>
//                             <th>Priority</th>
//                             <th>Status</th>
//                             <th>Due Date</th>
//                             <th>Notes</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {activities.length > 0 ? (
//                             activities.map((activity, index) => (
//                                 <tr key={activity.id}>
//                                     <td>{index + 1}</td>
//                                     <td><Link to={`/activity/details/${activity.id}`} className="dropdown-item">
//                                         {activity.subject}</Link></td>
//                                     <td>
//                                         <Link to={`/activity/details/${activity.id}`} className="dropdown-item">
//                                             {activity.activity_type}</Link>
//                                     </td>
//                                     <td>{activity.priority}</td>
//                                     <td>{activity.status}</td>
//                                     <td>{activity.due_date}</td>
//                                     <td>{activity.notes}</td>
//                                     <td>
//                                         <div className="dropdown">
//                                             <i
//                                                 className="mdi mdi-dots-horizontal font-size-18"
//                                                 data-bs-toggle="dropdown"
//                                                 aria-expanded="false"
//                                                 style={{ cursor: 'pointer' }}
//                                             ></i>
//                                             <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                                 <li>
//                                                     <Link to={`/activity/details/${activity.id}`} className="dropdown-item">
//                                                         View Details
//                                                     </Link>
//                                                 </li>
//                                                 <li>
//                                                     <WithEditPermission>
//                                                         <button
//                                                             className="dropdown-item"
//                                                             onClick={() => handleShowModal(activity.id)}
//                                                         >
//                                                             Edit
//                                                         </button>
//                                                     </WithEditPermission>
//                                                 </li>
//                                                 <li>
//                                                     <WithDeletePermission>
//                                                         <button
//                                                             className="dropdown-item"
//                                                             onClick={() => deleteActivity(activity.id)}
//                                                         >
//                                                             Delete
//                                                         </button>
//                                                     </WithDeletePermission>
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="8">No activities available</td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>

//                 <div className="d-flex justify-content-end pagination-sm">
//                     <ReactPaginate
//                         previousLabel={'<<'}
//                         nextLabel={'>>'}
//                         breakLabel={'...'}
//                         pageCount={pageCount}
//                         marginPagesDisplayed={2}
//                         pageRangeDisplayed={3}
//                         onPageChange={handlePageChange}
//                         containerClassName={'pagination justify-content-center pagination-sm'}
//                         pageClassName={'page-item'}
//                         pageLinkClassName={'page-link'}
//                         previousClassName={'page-item'}
//                         previousLinkClassName={'page-link'}
//                         nextClassName={'page-item'}
//                         nextLinkClassName={'page-link'}
//                         breakClassName={'page-item'}
//                         breakLinkClassName={'page-link'}
//                         activeClassName={'active'}
//                     />
//                 </div>
//             </>
//         );
//     };
//     return (
//         <React.Fragment>
//             {/* Conditionally wrap content in card and card-body only if type is 'deal' */}
//             <div>
//                 <div>
//                     <h4 className="mb-sm-0 font-size-18"></h4>
//                     <div className="d-flex justify-content-end mb-2">
//                         {/* Search Box */}
//                         <div className="search-box me-2">
//                             <div className="position-relative">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     placeholder="Search..."
//                                     value={searchQuery}
//                                     onChange={handleSearchChange}
//                                 />
//                                 <i className="bx bx-search-alt search-icon" />
//                             </div>
//                         </div>

//                         {/* Add Activity Button */}
//                         <WithCreatePermission>
//                             <button
//                                 type="button"
//                                 className="btn rounded-circle border d-flex align-items-center justify-content-center round-plus"

//                                 onClick={() => handleShowModal()}
//                                 data-bs-toggle="tooltip"
//                                 data-bs-placement="top"
//                                 id="tool"
//                                 title="Add Activity"
//                             >
//                                 <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
//                             </button>
//                         </WithCreatePermission>
//                     </div><br />

//                     <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >
//                         <thead>
//                             <tr>
//                                 <th scope="col">#</th>
//                                 <th scope="col">Subject</th>
//                                 <th scope="col">Activity Type</th>
//                                 <th scope="col">Priority</th>
//                                 <th scope="col">Status</th>
//                                 <th scope="col">Due Date</th>
//                                 <th scope="col">Notes</th>
//                                 <th scope="col">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {activities.length > 0 ? (
//                                 activities.map((activity, index) => (
//                                     <tr key={activity.id}>
//                                         <td>{index + 1}</td>
//                                         <td>
//                                             {activity.subject}</td>
//                                         <td>

//                                                 {activity.activity_type}
//                                         </td>
//                                         <td>{activity.priority}</td>
//                                         <td>{activity.status}</td>
//                                         <td>{activity.due_date}</td>
//                                         <td>{activity.notes}</td>
//                                         <td>
//                                             <div className="dropdown">
//                                                 <i
//                                                     className="mdi mdi-dots-horizontal font-size-18"
//                                                     data-bs-toggle="dropdown"
//                                                     aria-expanded="false"
//                                                     style={{ cursor: 'pointer' }}
//                                                 ></i>
//                                                 <ul className="dropdown-menu dropdown-menu-end font-size-14">

//                                                     <li>
//                                                         <WithEditPermission>
//                                                             <button
//                                                                 className="dropdown-item"
//                                                                 onClick={() => handleShowModal(activity.id)}
//                                                             >
//                                                                 Edit
//                                                             </button>
//                                                         </WithEditPermission>
//                                                     </li>
//                                                     <li>
//                                                         <WithDeletePermission>
//                                                             <button
//                                                                 className="dropdown-item"
//                                                                 onClick={() => deleteActivity(activity.id)}
//                                                             >
//                                                                 Delete
//                                                             </button>
//                                                         </WithDeletePermission>
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="8">No activities available</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>

//                     {/* <div className="d-flex justify-content-end pagination-sm">
//                         <ReactPaginate
//                             previousLabel={'<'}
//                             nextLabel={'>'}
//                             breakLabel={'...'}
//                             pageCount={pageCount}
//                             marginPagesDisplayed={2}
//                             pageRangeDisplayed={3}
//                             onPageChange={handlePageChange}
//                             containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                             pageClassName={'page-item'}
//                             pageLinkClassName={'page-link'}
//                             previousClassName={'page-item previous'}
//                             previousLinkClassName={'page-link'}
//                             nextClassName={'page-item next'}
//                             nextLinkClassName={'page-link'}
//                             breakClassName={'page-item'}
//                             breakLinkClassName={'page-link'}
//                             activeClassName={'active'}
//                         />

//                     </div> */}

//                 </div>
//             </div>


//             {/* Render the ActivityModal */}
//             <ActivityModal
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 activityId={selectedActivityId}
//                 activityData={selectedActivityData}
//                 addActivity={addActivity}
//                 editActivity={editActivity}
//                 errors={errors}
//                 setErrors={setErrors}
//             />
//         </React.Fragment>
//     );


// };
// export default ActivityList;





import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button, Card, Form, Badge, Table, Dropdown } from "react-bootstrap";
import { BsPlus, BsPencil, BsTrash, BsSearch, BsThreeDotsVertical } from "react-icons/bs";
import withPermission from '../../../../utils/withPermission';
import ActivityModal from './ActivityModal';
import Swal from 'sweetalert2';

const WithDeletePermission = withPermission(({ children }) => children, ['activity-delete']);
const WithEditPermission = withPermission(({ children }) => children, ['activity-edit']);
const WithCreatePermission = withPermission(({ children }) => children, ['activity-create']);

const ActivityList = ({ type, leadId, dealId, fetchLeadData, leadData, setLeadDetails, onModalShow, onModalClose }) => {
    const [activities, setActivity] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedActivityId, setSelectedActivityId] = useState(null);
    const [selectedActivityData, setSelectedActivityData] = useState(null);
    const [errors, setErrors] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const debounceTimeoutRef = useRef(null);



    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchActivity(1);
        }, searchQuery ? 500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);

    const fetchActivity = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activities`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    [`${type}_id`]: type === 'lead' ? leadId : dealId,
                    search: searchQuery,
                },

                skipLoader: true,

            });

            const activityData = response.data.data.data;
            setActivity(activityData);
            const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
            setPageCount(totalPages);
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    const addActivity = async (newActivity) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            newActivity[`${type}_id`] = type === 'lead' ? leadId : dealId;
            newActivity.type = type;

            const response = await axios.post(`${backendUrl}/api/activities?${type}_id=${type === 'lead' ? leadId : dealId}`, newActivity, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const createdActivity = response.data?.data;
            if (createdActivity) {
                setActivity((prevActivity) => [...prevActivity, createdActivity]);
            }
            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.message) {
                return error.response.data.message;
            } else {
                console.error('Error adding activity:', error);
            }
        }
    };

    const editActivity = async (activityId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            updatedData[`${type}_id`] = type === 'lead' ? leadId : dealId;
            const response = await axios.put(`${backendUrl}/api/activities/${activityId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedActivity = response.data?.data;
            if (updatedActivity) {
                setActivity((prevActivity) =>
                    prevActivity.map((activity) => (activity.id === updatedActivity.id ? updatedActivity : activity))
                );
            }
            handleCloseModal();
        } catch (error) {
            if (error.response && error.response.data.message) {
                setErrors(error.response.data.message);
            } else {
                console.error('Error updating activity:', error);
            }
        }
    };

    const deleteActivity = async (id) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.delete(`${backendUrl}/api/activities/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setActivity(activities.filter(activity => activity.id !== id));
            // Swal.fire("Deleted!", "The activity has been deleted.", "success");
        } catch (error) {
            console.error('Error deleting activity:', error);
            Swal.fire("Error!", "Failed to delete activity. Please try again.", "error");
        }


    };

    const handleShowModal = (activityId = null) => {
        if (activityId) {
            const activityToEdit = activities.find(activity => activity.id === activityId);
            setSelectedActivityData(activityToEdit || null);
        } else {
            setSelectedActivityData(null);
            setErrors({});
        }
        setSelectedActivityId(activityId);
        setShowModal(true);
        if (onModalShow) {
            setTimeout(() => {
                onModalShow();
            }, 500);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedActivityId(null);
        setSelectedActivityData(null);
        setErrors({});
        fetchActivity(currentPage);
        if (onModalClose) onModalClose();
    };

    const getPriorityBadge = (priority) => {
        const variants = {
            high: "danger",
            medium: "warning",
            low: "secondary"
        };
        return variants[priority?.toLowerCase()] || "secondary";
    };

    const getStatusBadge = (status) => {
        const variants = {
            completed: "success",
            'in progress': "primary",
            pending: "warning",
            cancelled: "danger"
        };
        return variants[status?.toLowerCase()] || "secondary";
    };

    const formatDate = (dateString) => {
        if (!dateString) return '--';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="activity-list-container">
            {/* Header with Search and Add Button */}
            <Card className="border-0 shadow-sm mb-3">
                <Card.Body className="py-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 className="mb-0 fw-bold text-dark">Activities</h6>
                            <small className="text-muted">Manage lead activities and tasks</small>
                        </div>
                        <div className="d-flex gap-2">
                            {/* Search Box */}
                            <div className="search-box">
                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        className="form-control-sm"
                                        placeholder="Search activities..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ width: '250px' }}
                                    />
                                    <BsSearch className="position-absolute top-50 end-0 translate-middle-y text-muted me-2" size={14} />
                                </div>
                            </div>

                            {/* Add Activity Button */}
                            <WithCreatePermission>
                                <Button
                                    size="sm"
                                    className="d-flex align-items-center gap-1"
                                    onClick={() => handleShowModal()}
                                >
                                    <BsPlus size={16} />
                                    Add Activity
                                </Button>
                            </WithCreatePermission>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            {/* Activities Table */}
            <Card className="border-0 shadow-sm">
                <Card.Body className="p-0">
                    {activities.length > 0 ? (
                        <div className="contacts-table-modern">
                            <div className="table-responsive">
                                <table className="table table-modern">
                                    <thead>

                                        <tr>
                                            <th className="ps-4">#</th>
                                            <th>Subject</th>
                                            <th>Activity Type</th>
                                            <th>Priority</th>
                                            {/* <th>Status</th> */}
                                            <th>Due Date</th>
                                            <th>Reminder</th>
                                            {/* <th>Notes</th> */}
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activities.map((activity, index) => (
                                            <tr key={activity.id} className="align-middle">
                                                <td className="ps-4 fw-semibold text-muted">{index + 1}</td>
                                                <td>
                                                    <div className="fw-semibold text-dark">{activity.subject}</div>
                                                </td>
                                                <td>
                                                    {activity.activityType?.name || activity.activity_type?.name ? (
                                                        <Badge style={{ backgroundColor: `${(activity.activityType?.color || activity.activity_type?.color)}20`, color: activity.activityType?.color || activity.activity_type?.color, fontSize: '11px' }}>
                                                            {activity.activityType?.name || activity.activity_type?.name}
                                                        </Badge>
                                                    ) : (
                                                        <span className="text-dark">{activity.activityType?.name || activity.activity_type?.name || '--'}</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <Badge bg={getPriorityBadge(activity.priority)} className="fw-normal">
                                                        {activity.priority || '--'}
                                                    </Badge>
                                                </td>
                                                {/* <td>
                                                    {activity.status || '--'}
                                                </td> */}
                                                <td>
                                                    <span className="text-dark">{formatDate(activity.due_date)}</span>
                                                </td>
                                                <td>
                                                    {activity.reminder_at ? (
                                                        <div className="text-warning small fw-bold">
                                                            <i className="bx bx-alarm me-1"></i>
                                                            {new Date(activity.reminder_at).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
                                                        </div>
                                                    ) : '--'}
                                                </td>
                                                {/* <td>
                                                    <span className="text-muted small">
                                                        {activity.notes ? (
                                                            activity.notes.length > 50 ?
                                                                `${activity.notes.substring(0, 50)}...` : activity.notes
                                                        ) : '--'}
                                                    </span>
                                                </td> */}
                                                <td className="text-center">
                                                    <Dropdown drop='up'>
                                                        <Dropdown.Toggle
                                                            variant="outline-light"
                                                            size="sm"
                                                            className="border-0 shadow-none"
                                                            id={`dropdown-${activity.id}`}
                                                        >
                                                            <BsThreeDotsVertical className="text-muted" />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu className="font-size-14">
                                                            <WithEditPermission>
                                                                <Dropdown.Item
                                                                    onClick={() => handleShowModal(activity.id)}
                                                                    className="d-flex align-items-center gap-2"
                                                                >
                                                                    <BsPencil size={14} />
                                                                    Edit
                                                                </Dropdown.Item>
                                                            </WithEditPermission>
                                                            <WithDeletePermission>
                                                                <Dropdown.Item
                                                                    onClick={() => deleteActivity(activity.id)}
                                                                    className="d-flex align-items-center gap-2 text-danger"
                                                                >
                                                                    <BsTrash size={14} />
                                                                    Delete
                                                                </Dropdown.Item>
                                                            </WithDeletePermission>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div className="text-muted">
                                <BsSearch size={32} className="mb-2 opacity-50" />
                                <p className="mb-1 fw-semibold">No activities found</p>
                                <small className="text-muted">Create your first activity to get started</small>
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Card>

            {/* Activity Modal */}
            <ActivityModal
                showModal={showModal}
                handleClose={handleCloseModal}
                activityId={selectedActivityId}
                activityData={selectedActivityData}
                addActivity={addActivity}
                editActivity={editActivity}
                errors={errors}
                setErrors={setErrors}
            />
        </div>
    );
};

export default ActivityList;


